import type { Usage as CheetahUsage, ErrorKind } from '@grammarly/cheetah-client-protocol/esm/types'

export enum CheetahMessageAction {
  Ack = 'cheetah',
  Result = 'cheetah:result',
  Chunk = 'cheetah:chunk',
  Error = 'cheetah:error',
  SetContext = 'cheetah:setContext',
}

export type CheetahErrorKind = `${ErrorKind}`

type CheetahError = {
  kind: CheetahErrorKind
  text: string
  title: string
}

type CheetahContext = {
  id: string
  stateBlob: string
}

type CheetahBaseMessage = {
  id: number
  promptId: number
}

export type CheetahResultMessage = CheetahBaseMessage & {
  usage: CheetahUsage
  context?: CheetahContext
  error?: CheetahError
}

export type CheetahChunkMessage = CheetahBaseMessage & {
  token: string
}

export type CheetahErrorMessage = CheetahBaseMessage & {
  error: CheetahError
}

export type CheetahSetContextMessage = CheetahBaseMessage & {
  usage: CheetahUsage
  context: CheetahContext
}

export class WSError {
  _msg: string
  _reason: unknown
  _promptSignup: 'popup' | undefined
  _kind: CheetahErrorKind | undefined

  constructor(_msg: string, _reason: unknown, _promptSignup?: 'popup', _kind?: CheetahErrorKind) {
    this._msg = _msg
    this._reason = _reason
    this._promptSignup = _promptSignup
    this._kind = _kind
  }
}
